import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CompanyView, ContactView } from '@api-proxies';
import { ContactService } from '@http/clients/contact.service';
import { TabNames } from '@models/enums/TabNames';
import { EditorComponentBase } from 'ngx-lib';
import { InternalNavigatorComponent } from '../../internal-navigator/internal-navigator.component';
import { TypeAheadContactsComponent } from '../../type-ahead-contacts/type-ahead-contacts.component';

interface ContactInfo {
    position: string;
    email: string;
    phone: string;
}

@Component({
    selector: 'app-company-main-contact-editor',
    templateUrl: './company-main-contact-editor.component.html',
    styleUrls: ['./company-main-contact-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [InternalNavigatorComponent, TypeAheadContactsComponent]
})
export class CompanyMainContactEditorComponent extends EditorComponentBase<number | undefined> implements OnInit {
    selectedItem?: ContactView;

    companyId: number | undefined;

    contactInfo: ContactInfo;

    displaySelectedContact: boolean;

    routeToSingle?: string;
    allowToNavigate?: boolean;

    constructor(private readonly contactService: ContactService) {
        super();
        this.displaySelectedContact = true;
        this.contactInfo = {
            position: '-',
            email: '-',
            phone: '-'
        };
    }

    async ngOnInit(): Promise<void> {
        this.companyId = (this.bindContext as CompanyView).id;
        this.allowToNavigate = this.additionalInfo?.allowToNavigate;

        if (this.bindingProperty) {
            this.selectedItem = await this.contactService.getById(this.bindingProperty);
            this.setContactInfo(this.selectedItem);
            if (this.allowToNavigate) this.setRouteToNavigate(this.selectedItem);
        }
    }

    onSelectedContact(contact: ContactView) {
        this.selectedItem = contact;
        this.bindingProperty = this.selectedItem?.id;
        this.setContactInfo(contact);
        if (this.allowToNavigate) this.setRouteToNavigate(contact);
    }

    setContactInfo(contact: ContactView) {
        const defaultEmptyText = '-';
        this.contactInfo.position = contact?.position ?? defaultEmptyText;
        this.contactInfo.email = contact?.email?.length ? contact.email[0] : defaultEmptyText;
        this.contactInfo.phone = contact?.phone?.length ? contact.phone[0] : defaultEmptyText;
    }

    setRouteToNavigate(contact: ContactView) {
        this.routeToSingle = `contacts-single/${contact.id}/${TabNames[TabNames.Overview]}`;
    }
}
